"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolution_gql = void 0;
exports.resolution_gql = `
query Resolution($entry_id: String!) {
    entry(entry_id: $entry_id) {
        rcsb_entry_info {
          resolution_combined
        }
    }
}
`;
